module.exports = __webpack_public_path__ + "img/ichijo-logo.005c8bec.png";